import { React, useState } from 'react';
import { useTranslation } from "react-i18next";
import {
  Accordion,
  Col,
  Button,
  ButtonGroup,
  InputGroup,
  Dropdown,
  Form,
  Row,
  Tab,
  Tabs,
  ListGroup,
  Table,
  Modal,
} from "react-bootstrap";



const FormDesignCOPY = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <main className="main overflow-hidden">
      <div className="formeditor-wrapper shadow-1 box-shadow-3">
        <div className="formeditor-header bg-white rounded-top d-flex justify-content-between align-items-center shadow-sm relative">
          <Button variant="editorclose border-0 bg-transparent border">
            <i className="bx bx-x bx-md"></i>
          </Button>
          <div className="headereditor-title border-start py-3 ps-3">
            <h3>Cybersecurity Admission Form</h3>
            <div className="headereditor-sub-title d-flex align-items-center">
              <i className="bx bx-folder bx-xs me-1"></i> Admission Form{" "}
            </div>
          </div>
          <div className="editor-tab p-1 rounded-2 d-flex gap-2 align-items-center mx-auto">
            <Button variant="editor btn-sm active">Fields</Button>
            <Button variant="editor btn-sm">Responses</Button>
            <Button variant="editor btn-sm">Form Setting</Button>
          </div>
          <div className="d-flex align-items-center">
            <div className="unduredo-btns d-flex align-items-center py-3">
              <Button variant="action btn-sm px-1">
                <i className="bx bx-undo bx-sm"></i>
              </Button>
              <Button variant="action btn-sm px-1">
                <i className="bx bx-redo bx-sm"></i>
              </Button>
            </div>
            <div className="editor-action-btns ms-2 d-flex gap-2 align-items-center py-3 px-3">
              <Button variant="gray-light btn-sm bx-sm view-btn">
                <i className="bx bx-show-alt"></i>
              </Button>
              <Button variant="gray-light btn-sm">Save</Button>
              <Button variant="primary btn-sm">Publish</Button>
            </div>
          </div>
        </div>
        <div className="d-flex rounded-bottom overflow-hidden align-items-start bg-white rounded-bottom-3 formbuilder-body">
          <div className="formeditor-sidebar sidebar-left p-3 bg-white rounded-left-bottom-1 global-tab">

          <ul className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active" id="nav-elements-tab" data-bs-toggle="pill" data-bs-target="#nav-elements" type="button" role="tab" aria-controls="nav-elements" aria-selected="true">Elements</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="nav-advance-tab" data-bs-toggle="pill" data-bs-target="#nav-advance" type="button" role="tab" aria-controls="nav-advance" aria-selected="false">Advance</button>
            </li>
          </ul>
          <div className="tab-content" id="nav-tabContent">
            <div className="tab-pane fade show active" id="nav-elements" role="tabpanel" aria-labelledby="nav-elements-tab" tabindex="0">
              <div className="search-div mb-3">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="pluto-search"></i>
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search element"
                  />
                </div>
              </div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Text Elements</Accordion.Header>
                  <Accordion.Body>
                    <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          notes
                        </span>{" "}
                        Short text
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          subject
                        </span>{" "}
                        Long text
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle bx-sm">
                          123
                        </span>{" "}
                        Number
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          info
                        </span>{" "}
                        Description
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Choice Elements</Accordion.Header>
                  <Accordion.Body>
                    <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          toggle_on
                        </span>{" "}
                        Yes/No
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          expand_more
                        </span>{" "}
                        Dropdown
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          checklist
                        </span>{" "}
                        Multiple
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          priority
                        </span>{" "}
                        Checkbox
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          radio_button_checked
                        </span>{" "}
                        Radio Button
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          priority
                        </span>{" "}
                        Confirmation
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          view_list
                        </span>{" "}
                        Multi Input Grid
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          fact_check
                        </span>{" "}
                        Auto Complete
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>Contact Elements</Accordion.Header>
                  <Accordion.Body>
                    <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          location_on
                        </span>{" "}
                        Address
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          call
                        </span>{" "}
                        Phone No
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          alternate_email
                        </span>{" "}
                        Email
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          link
                        </span>{" "}
                        Website
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Date Elements</Accordion.Header>
                  <Accordion.Body>
                    <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          calendar_month
                        </span>{" "}
                        Date/Time
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="bx bx-copyright align-middle"></span>{" "}
                        Calendly
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="bx bxl-google align-middle"></span>{" "}
                        Google Calender
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>Media Elements</Accordion.Header>
                  <Accordion.Body>
                    <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          upload
                        </span>{" "}
                        File Upload
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          download
                        </span>{" "}
                        Download
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          image
                        </span>{" "}
                        Image
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          videocam
                        </span>{" "}
                        Video
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>Layout Elements</Accordion.Header>
                  <Accordion.Body>
                    <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                      <div className="btn btn-gray-light btn-sm">
                        <span className="pluto-page-breaker"></span> Page
                        Breaker
                      </div>

                      <div className="btn btn-gray-light btn-sm">
                        <span className="pluto-section"></span> Section
                      </div>

                      <div className="btn btn-gray-light btn-sm">
                        <span className="pluto-button"></span> Button
                      </div>

                      <div className="btn btn-gray-light btn-sm">
                        <i className="bx bx-link"></i> Link
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>Advance elements</Accordion.Header>
                  <Accordion.Body>
                    <div className="drag-buttons d-inline-flex flex-wrap gap-2">
                      <div className="btn btn-gray-light btn-sm">
                        <span className="pluto-signature"></span> Signature
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          credit_card
                        </span>{" "}
                        Payment
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="material-symbols-outlined align-middle">
                          star
                        </span>{" "}
                        Ratings
                      </div>
                      <div className="btn btn-gray-light btn-sm">
                        <span className="bx bx-code-alt align-middle bx-sm"></span>{" "}
                        Embed Code
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            <div className="tab-pane fade" id="nav-advance" role="tabpanel" aria-labelledby="nav-advance-tab" tabindex="0">
              <div className="search-div mb-3">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="pluto-search"></i>
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Advance Search"
                  />
                </div>
              </div>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Local Database</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex flex-column row-gap-3">
                      <div className="drag-cursor p-4 rounded border border-grey-200 bg-grey-100 d-flex flex-column row-gap-2">
                        <h4 className="text-sm font-medium text-grey-700">Candidate Name</h4>
                        <div className="text-xs text-grey-600"><span className="material-symbols-outlined align-middle text-lg">notes</span> Short text</div>
                        <div className="text-xs text-grey-400 font-medium">Created at 22-01-2022</div>
                      </div>
                      <div className="drag-cursor p-4 rounded border border-grey-200 bg-grey-100 d-flex flex-column row-gap-2">
                        <h4 className="text-sm font-medium text-grey-700">Candidate Nationality</h4>
                        <div className="text-xs text-grey-600"><span className="material-symbols-outlined align-middle text-lg rounded-2 border border-grey-300">expand_more</span> Dropdown</div>
                        <div className="text-xs text-grey-400 font-medium">Created at 22-01-2022</div>
                      </div>
                      <div className="drag-cursor p-4 rounded border border-grey-200 bg-grey-100 d-flex flex-column row-gap-2">
                        <h4 className="text-sm font-medium text-grey-700">Educational Qualification</h4>
                        <div className="text-xs text-grey-600"><span className="material-symbols-outlined align-middle text-lg rounded-2 border border-grey-300">expand_more</span> Dropdown</div>
                        <div className="text-xs text-grey-400 font-medium">Created at 22-01-2022</div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Global Section</Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex flex-column row-gap-3">
                      <div className="p-4 rounded border border-grey-200 bg-grey-100 d-flex flex-column row-gap-2">
                        <h4 className="text-sm font-medium text-grey-700">Candidate Basic Details</h4>
                        <div className="d-flex flex-column row-gap-3">
                          <div className="drag-cursor text-xs text-grey-600 d-flex align-items-center gap-2">
                            <span className="material-symbols-outlined align-middle text-lg">notes</span><span className="line-clamp-1 d-block">Candidate Name</span><small className="text-nowrap">Short text</small>
                          </div>
                          <div className="drag-cursor text-xs text-grey-600 d-flex align-items-center gap-2">
                            <span className="material-symbols-outlined align-middle text-lg rounded-2 border border-grey-300">expand_more</span><span className="line-clamp-1 d-block">Candidate Name</span><small className="text-nowrap">Short text</small>
                          </div>
                          <div className="drag-cursor text-xs text-grey-600 d-flex align-items-center gap-2">
                            <span className="material-symbols-outlined align-middle text-lg">notes</span><span className="line-clamp-1 d-block">Candidate Name</span><small className="text-nowrap">Short text</small>
                          </div>
                          <div className="drag-cursor text-xs text-grey-600 d-flex align-items-center gap-2">
                            <span className="material-symbols-outlined align-middle text-lg rounded-2 border border-grey-300">expand_more</span><span className="line-clamp-1 d-block">Candidate Name</span><small className="text-nowrap">Short text</small>
                          </div>
                        </div>
                        <div className="text-xs text-grey-400 font-medium">Created at 22-01-2022</div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
            
          </div>
          <div className="formeditor-view ms-auto sidebar-right p-3 border-end border-start h-100">
            <div className="p-3 rounded-2 bg-white border scroll-y">
              <div className="section-divider text-center mb-4">
                <span className="bg-white">Add section header</span>
              </div>
              <Row className="row gy-4">
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined me-2">
                          view_list
                        </span>{" "}
                        Multi Input Grid
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined copy-btn me-2">
                            settings
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Label>Add your Question here.</Form.Label>
                        <Table className="builder-grid-table">
                          <thead>
                            <tr>
                              <th></th>
                              <th>Column 1</th>
                              <th>Column 2</th>
                              <th>Column 3</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Row 1</td>
                              <td>
                                {["radio"].map((type) => (
                                  <Form.Group
                                    key={`default-${type}`}
                                    className=""
                                  >
                                    <Form.Check
                                      // label="Yes"
                                      name="row1"
                                      type={type}
                                      id={`reverse-${type}-1`}
                                    />
                                  </Form.Group>
                                ))}
                              </td>
                              <td>
                                {["radio"].map((type) => (
                                  <Form.Group
                                    key={`default-${type}`}
                                    className=""
                                  >
                                    <Form.Check
                                      // label="Yes"
                                      name="row1"
                                      type={type}
                                      id={`reverse-${type}-2`}
                                    />
                                  </Form.Group>
                                ))}
                              </td>
                              <td>
                                {["radio"].map((type) => (
                                  <Form.Group
                                    key={`default-${type}`}
                                    className=""
                                  >
                                    <Form.Check
                                      // label="Yes"
                                      name="row1"
                                      type={type}
                                      id={`reverse-${type}-3`}
                                    />
                                  </Form.Group>
                                ))}
                              </td>
                            </tr>
                            <tr>
                              <td>Row 2</td>
                              <td>
                                {["radio"].map((type) => (
                                  <Form.Group
                                    key={`default-${type}`}
                                    className=""
                                  >
                                    <Form.Check
                                      // label="Yes"
                                      name="row2"
                                      type={type}
                                      id={`reverse-${type}-1`}
                                    />
                                  </Form.Group>
                                ))}
                              </td>
                              <td>
                                {["radio"].map((type) => (
                                  <Form.Group
                                    key={`default-${type}`}
                                    className=""
                                  >
                                    <Form.Check
                                      // label="Yes"
                                      name="row2"
                                      type={type}
                                      id={`reverse-${type}-2`}
                                    />
                                  </Form.Group>
                                ))}
                              </td>
                              <td>
                                {["radio"].map((type) => (
                                  <Form.Group
                                    key={`default-${type}`}
                                    className=""
                                  >
                                    <Form.Check
                                      // label="Yes"
                                      name="row2"
                                      type={type}
                                      id={`reverse-${type}-3`}
                                    />
                                  </Form.Group>
                                ))}
                              </td>
                            </tr>
                            <tr>
                              <td>Row 3</td>
                              <td>
                                {["radio"].map((type) => (
                                  <Form.Group
                                    key={`default-${type}`}
                                    className=""
                                  >
                                    <Form.Check
                                      // label="Yes"
                                      name="row3"
                                      type={type}
                                      id={`reverse-${type}-1`}
                                    />
                                  </Form.Group>
                                ))}
                              </td>
                              <td>
                                {["radio"].map((type) => (
                                  <Form.Group
                                    key={`default-${type}`}
                                    className=""
                                  >
                                    <Form.Check
                                      // label="Yes"
                                      name="row3"
                                      type={type}
                                      id={`reverse-${type}-2`}
                                    />
                                  </Form.Group>
                                ))}
                              </td>
                              <td>
                                {["radio"].map((type) => (
                                  <Form.Group
                                    key={`default-${type}`}
                                    className=""
                                  >
                                    <Form.Check
                                      // label="Yes"
                                      name="row3"
                                      type={type}
                                      id={`reverse-${type}-3`}
                                    />
                                  </Form.Group>
                                ))}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="pluto-section me-2"></span> Section
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined copy-btn me-2">
                            settings
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="shorttext">
                          <Form.Label>
                            Add your Question here.
                            <small className="d-block">
                              This will help us ensure accurate communication
                              and correspondence throughout the admission
                              process.
                            </small>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Search element"
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          notes
                        </span>{" "}
                        Short text
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined copy-btn me-2">
                            settings
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="shorttext">
                          <Form.Label>
                            Add your Question here.
                            <small className="d-block">
                              This will help us ensure accurate communication
                              and correspondence throughout the admission
                              process.
                            </small>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Search element"
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          subject
                        </span>{" "}
                        Long Text
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="longtext">
                          <Form.Label>
                            Add your Question here.
                            <small className="d-block">
                              This will help us ensure accurate communication
                              and correspondence throughout the admission
                              process.
                            </small>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            placeholder="Search element"
                            rows={2}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle bx-md me-2">
                          123
                        </span>{" "}
                        Number
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="number">
                          <Form.Label>Add your Question here.</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Search element"
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          info
                        </span>{" "}
                        Description
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="description">
                          <Form.Label>Add your Question here.</Form.Label>
                          <Form.Control
                            as="textarea"
                            placeholder="Search element"
                            rows={4}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="description">
                          <Form.Label>Add your Question here.</Form.Label>
                          <Form.Control
                            as="textarea"
                            placeholder="Search element"
                            rows={4}
                            className="is-invalid"
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          checklist
                        </span>{" "}
                        Multiple Select
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Label>Select yours Option</Form.Label>
                        <div className="select-group-custom">
                          <div className="selected-options-custom px-1 pt-1 pb-1 rounded-2 border bg-white mb-2 d-inline-flex flex-wrap row-gap-1">
                            <span className="selected-option-custom d-inline-block me-1 px-2 py-1 text-xxs leading-1 font-semibold text-slate-500 rounded-1 border border-blue-200 bg-blue-100">
                              pt yaarezUoeoei sa iv nmniRSLf
                              <span className="remove-icon">×</span>
                            </span>
                            <span className="selected-option-custom d-inline-block me-1 px-2 py-1 text-xxs leading-1 font-semibold text-slate-500 rounded-1 border border-blue-200 bg-blue-100">
                              suebtTyairvk inu
                              <span className="remove-icon">×</span>
                            </span>
                            <span className="selected-option-custom d-inline-block me-1 px-2 py-1 text-xxs leading-1 font-semibold text-slate-500 rounded-1 border border-blue-200 bg-blue-100">
                              tToic ilInliclihhtsaofi aaorloTNpneuta pt gyneru
                              <span className="remove-icon">×</span>
                            </span>
                            <span className="selected-option-custom d-inline-block me-1 px-2 py-1 text-xxs leading-1 font-semibold text-slate-500 rounded-1 border border-blue-200 bg-blue-100">
                              yaiUinOC veirsytk tsa
                              <span className="remove-icon">×</span>
                            </span>
                            <span className="selected-option-custom d-inline-block me-1 px-2 py-1 text-xxs leading-1 font-semibold text-slate-500 rounded-1 border border-blue-200 bg-blue-100">
                              hnii SgravdeSln Ueifcd etua ccennTosyn oyo
                              <span className="remove-icon">×</span>
                            </span>
                            <span className="selected-option-custom d-inline-block me-1 px-2 py-1 text-xxs leading-1 font-semibold text-slate-500 rounded-1 border border-blue-200 bg-blue-100">
                              UrevrmraMtinsiya a
                              <span className="remove-icon">×</span>
                            </span>
                            <input
                              className="search-input border-0 text-xs"
                              placeholder="e.g. Search"
                              type="text"
                              value=""
                            />
                          </div>
                          <div className="select-dropdown-custom max-h-250 overflow-auto">
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              Select All
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              pt yaarezUoeoei sa iv nmniRSLf
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />{" "}
                              nvWmig Uoeiyornfisyt
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              suebtTyairvk inu
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              tToic ilInliclihhtsaofi aaorloTNpneuta pt gyneru
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              yaiUinOC veirsytk tsa
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              hnii SgravdeSln Ueifcd etua ccennTosyn oyo
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              gs bnahymt aeointoci e nniTItufMdIluo
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              ieyjoaenUBimi sgr tirvlNn
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              ittUteaS nry shaetUiv
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              yzrn vsistiAoniatrtu aee
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              tiiUCmCEvrh oileirau nnhte eoPasntafsy
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              UrevrmraMtinsiya a
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />{" "}
                              raieshtmn snsvuayii
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />{" "}
                              Uh i vnyNsahheTEinofga lncncy CoogarCit,ai,thnesan
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              N BzRUlFa,ir
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              rictcyUfmAf yi nshnv eeesiSeeicnoCe dsoa
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              StyUNAnanlve a, nieidui selr
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              osiMlrT ogsaaiiytneak eilUnvi
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              nrtHslnUieayi wev
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              tegrhnyDiusa Uivon
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              srGciytMlevUi nli
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              eCeepdas tne ii cntlrcvynyhfaoniuooatgl sci
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              ohgiav heseeceidina i e,fircjysAeC i ftnonicCmn
                              Bnse,USy
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              iy eTieonclfes ccvodiagnry hiUCnno nhocetS
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              Ntisevt no SofrueiayhWUwsle
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              sitOe, anCrniCc neanyihoUfvai h
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              ,eynndoaenhrsiDivroDtU u
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              UeiovMhisnna tsry
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />{" "}
                              aCSr dooMohoios cflelon
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              lmskr eoiaantfv iyUOoh
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              si UhSJhignnveroTiaa iytona g
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              inra eysUTc gevrSLeiiefnhnsco Neifeo wit
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              emU hfiooyneiPrtCl e tiuvsnra
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              oiaUniysvr Ciret
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              eEfiFnr g,etioa at DlaucnyiSm rcs c,p oyvyutenhu
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              eFrnle)ceie syi(ari fuloar Mnvst
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              V gTSZRaIzagYEUNIi
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              iKsievyhsuut rUyn
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              hs rtvniieaeyiZjUng
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />{" "}
                              atv aTeNJnaon doaunle oSt,aaUuwhcany
                              ycnaciFaezlsiaeiyKn ,rtg pfrcl
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              non s sgeoensyigfiathRmii p,oval e,isio
                              tTiucehpneeoGlticchra LtintonfnCc a mcsaSnl
                              ,tsioinae oUtI
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              sUnTe deDr
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />{" "}
                              voire itrUomsKfnayhtu
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              tMia aanefvysOliUy r
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              f h.ncn dTSSUc uaeoad
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />{" "}
                              aea nK ,UN,iaotgiryoKnByrs eaiiverno
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              tyipu vhaJu,neis ynUKsra
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              irasutvlaiiye enfo gmelG uAr
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              Muieritl WniashndA alnryaKvda Ub
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              &amp;xMA sTea
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              aapadsnrAh 0ys,e3vhi0nkaaia nrmt, n3VU5ii0Itd
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              iysneUiurvWnhta
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              aaiyk la asrheMphvlBdsaunhhdu ttaPr ylberioa
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              Pe LEltuilraaesaelp éocri coroildn Stuic
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              c lnch ieceenl yertldvoSaiT n1seyn–UgLii o
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              uhisncs acyr de tv scrfeitiSineo MeniUo
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              MiToucan etfrE iosthinyd
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              inoizcarveuyibt sig
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              y, n ciriu icfyvotnU tSerFluscDeaanamhe
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              lrimsaoniiitUtCryhB e obs vufi
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              sv ehtPbnrejeyuar tiahfU ioon L
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              ePai hix osCg cGwlfoN,reottilecfoaiyenEUyeaoael
                              renn lrtnsnev
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />{" "}
                              sAiyrianv-eztrAhlU
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />{" "}
                              ainiass iaUinitvMraylseS
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              aysntrinuaims ievo
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              na, aIuosaes kihn af roamtDPtyiipihvwamep fBrt ols
                              na legyrU,erataGphet
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              nyUnfaot seJervi i
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              ltSySaSgroeotd nm eiRtnfacnnepaenotc cu
                              oesreiiaNhsA i
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              nldretverAniiyxUa isa
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              src aGtenlilCUalyanitn ch ueamvyTirshe
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              irtzedeäSswair/t erBventninUl
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              lu,Cn ayedbiZnNteUr eirfarawvsoye t n
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              jnthu
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              Sltneti iarvnieza G ,esUenrwyvfo
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              naAUethrsvmS nsiyi i
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              ieaaanmvsiiA nytrlnU
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              igcinazibyvsriueot
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              urytUniiCrvt nise
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              UhtstiGirfeyifv nri
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              EAAT HAA BYSVADAOA SOORJRAERRMFINJAYUIHIT
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              Tieastv shiigruyUnn
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              soniClerfyt if necnoha otys hoiee cnenrE
                              Uivcdailcncgto
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              ey iioyrtfUevndToSlhsno gycey n
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              i adtnUorivetrsP yiS
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              Ueslyuni Uadrvgit
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              ss OeR fntsniGso aUntt dileSraaii uvay
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              aeseiroieelyGfnkrc r,viss TnitAeool stih Ute
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              igeeeyat d vrUiKnUtmgidesd,Ronin in
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              Urlieyaeyisnvhs Tst
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              otioMyao-cl tiey a ,nvsfUcncIilairB
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              yMrU neh d Egnootnn lyer onevgrhangiifecneisaTi
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              iiOevCseUitrnsK
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              fielddttgItnoconnat cst euhHunyaociie ss e nn
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              sUeiCoyritvai nr
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              vcasrcUnenIaT ntishetliiylbu
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              d th inaei,nnUCeniAyi, annsIarv
                            </label>
                            <label className="d-flex text-sm mb-2">
                              <input
                                className="form-check-input me-2"
                                type="checkbox"
                              />
                              aenso no n epdia tCieta,DvngimsJSa hLoenduh,E
                              enaiEp a rvwhirotntnygieengnmC rrs,tedinnucnUettg
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          toggle_on
                        </span>{" "}
                        Yes / No
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        {["radio"].map((type) => (
                          <Form.Group key={`default-${type}`} className="mb-3">
                            <Form.Label>Add your Question here.</Form.Label>
                            <Form.Check
                              className="is-invalid"
                              label="Yes"
                              name="yesno"
                              type={type}
                              id={`reverse-${type}-1`}
                            />
                            <Form.Check
                              label="No"
                              name="yesno"
                              type={type}
                              id={`reverse-${type}-2`}
                            />
                          </Form.Group>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          radio_button_checked
                        </span>{" "}
                        Radio Button
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        {["radio"].map((type) => (
                          <Form.Group key={`default-${type}`} className="mb-3">
                            <Form.Label>Add your Question here.</Form.Label>
                            <Form.Check
                              label="Option 1"
                              name="Option"
                              type={type}
                              id={`option-${type}-1`}
                            />
                            <Form.Check
                              label="Option 2"
                              name="Option"
                              type={type}
                              id={`option-${type}-2`}
                            />
                            <Form.Check
                              label="Option 3"
                              name="Option"
                              type={type}
                              id={`option-${type}-2`}
                            />
                          </Form.Group>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          checklist
                        </span>{" "}
                        Checkbox
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        {["checkbox"].map((type) => (
                          <Form.Group key={`default-${type}`}>
                            <Form.Label>Add your Question here.</Form.Label>
                            <div className="mb-2">
                              <Form.Check
                                className="is-invalid"
                                type={type}
                                id={`default-${type}`}
                                label={`Value 1`}
                              />
                            </div>

                            <div className="mb-2">
                              <Form.Check
                                type={type}
                                id={`disabled-default-${type}`}
                                label={`Value 2`}
                              />
                            </div>

                            <div className="mb-2">
                              <Form.Check
                                type={type}
                                id={`disabled-default-${type}`}
                                label={`Value 3`}
                              />
                            </div>
                          </Form.Group>
                        ))}

                        <Button variant="gray-light">
                          <i className="bx bxs-plus-circle"></i> Add more
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          priority
                        </span>{" "}
                        Confirmation
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        {["checkbox"].map((type) => (
                          <Form.Group key={`default-${type}`}>
                            <Form.Label>Add your Question here.</Form.Label>
                            <div className="mb-2">
                              <Form.Check // prettier-ignore
                                type={type}
                                id={`default-${type}`}
                                label={`By submitting this form, I certify that all the information provided in this application is true and correct. I am aware that it is an offence to make a false statement or include inaccurate information in this application.`}
                              />
                            </div>
                          </Form.Group>
                        ))}
                        {/* <Button variant="gray-light">
                          <i className="bx bxs-plus-circle"></i> Add more
                        </Button> */}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          expand_more
                        </span>{" "}
                        Dropdown
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        {/* <Form.Label>Add your Question here.</Form.Label>
                                    <div className="dropdown-search search-div">
                                        <DropdownButton variant="gray-light border arrow-btn" id="dropdown-basic-button" title="Afganisthan">
                                            <div className="p-3 ">
                                                <InputGroup className="mb-3">
                                                    <InputGroup.Text id="basic-addon1"><i className="pluto-search"></i></InputGroup.Text>
                                                    <Form.Control
                                                    placeholder="Search option"
                                                    aria-label="Username"
                                                    aria-describedby="basic-addon1"
                                                    />
                                                </InputGroup>
                                                <div className="counrty-list">
                                                    <ul className="m-0 p-0">
                                                        <li>India</li>
                                                        <li>UAE</li>
                                                        <li>Afganisthan</li>
                                                        <li>Oman</li>
                                                        <li>Dubai</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </DropdownButton>
                                    </div> */}

                        <Form.Group className="mb-3" controlId="counrty">
                          <Form.Label>Add your Question here.</Form.Label>
                          <Form.Select className="is-invalid">
                            <option>Afganisthan</option>
                            <option>Dubai</option>
                            <option>India</option>
                            <option>Oman</option>
                            <option>UK</option>
                            <option>UAE</option>
                            <option>USA</option>
                          </Form.Select>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          call
                        </span>{" "}
                        Phone No
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="phone">
                          <Form.Label>Add your Question here.</Form.Label>
                          <InputGroup>
                            <InputGroup.Text id="basic-addon1" className="p-0">
                              <Form.Select className="border-0 rounded-end-0">
                                <option>+91</option>
                                <option>+1</option>
                                <option>+12</option>
                                <option>+20</option>
                                <option>+92</option>
                                <option>+93</option>
                                <option>+94</option>
                                <option>+95</option>
                              </Form.Select>
                            </InputGroup.Text>
                            <Form.Control
                              type="tel"
                              placeholder="Enter phone number"
                              aria-label="phno"
                              aria-describedby="basic-addon1"
                            />
                          </InputGroup>
                        </Form.Group>
                        {/* <input type="text" className="form-control" placeholder="Search element" /> */}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          alternate_email
                        </span>{" "}
                        Email
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="email">
                          <Form.Label>Add your Question here.</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter Email Address"
                            aria-describedby="passwordHelpBlock"
                          />
                        </Form.Group>

                        <input
                          type="text"
                          className="form-control is-invalid"
                          id="validationServer03"
                          aria-describedby="validationServer03Feedback"
                          required
                        />
                        <div
                          id="validationServer03Feedback"
                          className="invalid-feedback"
                        >
                          Please provide a valid city.
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          calendar_month
                        </span>{" "}
                        Date / Time
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Row>
                          <Col xs={6} sm={6}>
                            <Form.Group className="mb-3" controlId="date">
                              <Form.Label>Date</Form.Label>
                              <Form.Control type="date" aria-describedby="" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="date">
                              <Form.Label>Date</Form.Label>
                              <Form.Control
                                type="date"
                                aria-describedby=""
                                className="is-invalid"
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6} sm={6}>
                            <Form.Group className="mb-3" controlId="time">
                              <Form.Label>Date</Form.Label>
                              <Form.Control type="time" aria-describedby="" />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          star
                        </span>{" "}
                        Rating
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Label>Add your Question here</Form.Label>
                        <div className="rating-items d-flex align-items-center gap-2">
                          <input
                            type="checkbox"
                            className="btn-check"
                            id="btn-check"
                            autocomplete="off"
                          />
                          <label
                            className="btn btn-transparent border-0 px-0"
                            for="btn-check"
                          >
                            <span className="bx bxs-star bx-sm"></span>
                          </label>

                          <input
                            type="checkbox"
                            className="btn-check"
                            id="btn-check-2"
                            autocomplete="off"
                          />
                          <label
                            className="btn btn-transparent border-0 px-0"
                            for="btn-check-2"
                          >
                            <span className="bx bxs-star bx-sm"></span>
                          </label>

                          <input
                            type="checkbox"
                            className="btn-check"
                            id="btn-check-3"
                            autocomplete="off"
                          />
                          <label
                            className="btn btn-transparent border-0 px-0"
                            for="btn-check-3"
                          >
                            <span className="bx bxs-star bx-sm"></span>
                          </label>

                          <input
                            type="checkbox"
                            className="btn-check"
                            id="btn-check-4"
                            autocomplete="off"
                          />
                          <label
                            className="btn btn-transparent border-0 px-0"
                            for="btn-check-4"
                          >
                            <span className="bx bxs-star bx-sm"></span>
                          </label>

                          <input
                            type="checkbox"
                            className="btn-check"
                            id="btn-check-5"
                            autocomplete="off"
                          />
                          <label
                            className="btn btn-transparent border-0 px-0"
                            for="btn-check-5"
                          >
                            <span className="bx bxs-star bx-sm"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          image
                        </span>{" "}
                        Image
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Label>This is test caption</Form.Label>
                        <div className="">
                          <img
                            src="../assets/images/items/post-img.jpg"
                            alt=""
                            className="d-block rounded-2 img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          videocam
                        </span>{" "}
                        Video
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Label>This is test caption</Form.Label>
                        <div className="video-iframe video-iframe-sm rounded-3 position-relative overflow-hidden">
                          <iframe
                            width="1280"
                            height="720"
                            src="https://www.youtube.com/embed/mr15Xzb1Ook"
                            title="Tailwind in 100 Seconds"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          info
                        </span>{" "}
                        Description
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <div className="p-3 rounded-3 border bg-white text-sm">
                          <h1 className="h5">
                            Welcome to the EdTech UX Survey!
                          </h1>
                          <p>🌟 Greetings!</p>
                          <p>
                            Thank you for taking the time to participate in our
                            survey. Your feedback is invaluable to us as we
                            strive to revolutionize the university admission
                            process.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          location_on
                        </span>{" "}
                        Address
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Row className="">
                          <Col xs sm="12" md="6">
                            <Form.Group className="mb-3" controlId="flat">
                              <Form.Label>Flat/House No</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Flat/House No"
                              />
                            </Form.Group>
                          </Col>
                          <Col xs sm="12" md="6">
                            <Form.Group className="mb-3" controlId="address">
                              <Form.Label>Address</Form.Label>
                              <Form.Control type="text" placeholder="Address" />
                            </Form.Group>
                          </Col>
                          <Col xs sm="12" md="6">
                            <Form.Group className="mb-3" controlId="country">
                              <Form.Label>Country</Form.Label>
                              <Form.Control type="text" placeholder="Country" />
                            </Form.Group>
                          </Col>
                          <Col xs sm="12" md="6">
                            <Form.Group className="mb-3" controlId="state">
                              <Form.Label>State</Form.Label>
                              <Form.Control type="text" placeholder="State" />
                            </Form.Group>
                          </Col>
                          <Col xs sm="12" md="6">
                            <Form.Group className="mb-3" controlId="city">
                              <Form.Label>City</Form.Label>
                              <Form.Control type="text" placeholder="City" />
                            </Form.Group>
                          </Col>
                          <Col xs sm="12" md="6">
                            <Form.Group className="mb-3" controlId="pin">
                              <Form.Label>Pin-code</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Pin-code"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          upload
                        </span>{" "}
                        File Upload
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Label>Add your Question here</Form.Label>
                        <div className="mb-3 file-input-box bg-white border rounded">
                          <label for="file" className="d-block p-5 text-center">
                            <span className="material-symbols-outlined">
                              cloud_upload
                            </span>
                            <h5 className="mb-0">
                              <strong>Choose file</strong> or{" "}
                              <strong>Drag here</strong>
                            </h5>
                            <small>File Size 20 MB</small>
                          </label>
                          <input type="file" id="file" className="d-none" />
                        </div>
                        <div className="file-view-list d-flex flex-wrap gap-2 mb-3">
                          <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                            <i className="bx bxs-file-pdf"></i>{" "}
                            <label className="ms-1">PDF file.pdf</label>
                            <button className="bg-transparent border-0 close-btn">
                              <i className="bx bx-x"></i>
                            </button>
                          </div>
                          <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                            <i className="bx bxs-file-jpg"></i>{" "}
                            <label className="ms-1">JPG file.jpg</label>
                            <button className="bg-transparent border-0 close-btn">
                              <i className="bx bx-x"></i>
                            </button>
                          </div>
                          <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                            <i className="bx bxs-file-png"></i>{" "}
                            <label className="ms-1">PNG file.png</label>
                            <button className="bg-transparent border-0 close-btn">
                              <i className="bx bx-x"></i>
                            </button>
                          </div>
                          <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                            <i className="bx bxs-file-doc"></i>{" "}
                            <label className="ms-1">Document file.doc</label>
                            <button className="bg-transparent border-0 close-btn">
                              <i className="bx bx-x"></i>
                            </button>
                          </div>
                        </div>

                        <div className="mb-3 file-input-box bg-white border rounded is-invalid">
                          <label for="file" className="d-block p-5 text-center">
                            <span className="material-symbols-outlined">
                              cloud_upload
                            </span>
                            <h5 className="mb-0">
                              <strong>Choose file</strong> or{" "}
                              <strong>Drag here</strong>
                            </h5>
                            <small>File Size 20 MB</small>
                          </label>
                          <input type="file" id="file" className="d-none" />
                        </div>
                        <div className="file-view-list d-flex flex-wrap gap-2">
                          <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                            <i className="bx bxs-file-pdf"></i>{" "}
                            <label className="ms-1">PDF file.pdf</label>
                            <button className="bg-transparent border-0 close-btn">
                              <i className="bx bx-x"></i>
                            </button>
                          </div>
                          <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                            <i className="bx bxs-file-jpg"></i>{" "}
                            <label className="ms-1">JPG file.jpg</label>
                            <button className="bg-transparent border-0 close-btn">
                              <i className="bx bx-x"></i>
                            </button>
                          </div>
                          <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                            <i className="bx bxs-file-png"></i>{" "}
                            <label className="ms-1">PNG file.png</label>
                            <button className="bg-transparent border-0 close-btn">
                              <i className="bx bx-x"></i>
                            </button>
                          </div>
                          <div className="file-view-details py-2 px-2 ms-2 bg-white border rounded d-flex align-items-center">
                            <i className="bx bxs-file-doc"></i>{" "}
                            <label className="ms-1">Document file.doc</label>
                            <button className="bg-transparent border-0 close-btn">
                              <i className="bx bx-x"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          download
                        </span>{" "}
                        File Download
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Label>Add your Question here</Form.Label>
                        <ul className="download-list m-0 p-0">
                          <li className="download-item ps-2 py-1 rounded-1 border bg-white d-flex align-items-center">
                            <div className="download-item-detsils d-flex align-items-center">
                              <i className="bx bxs-file-pdf"></i>{" "}
                              <label className="ms-2">Instruction.pdf</label>{" "}
                              <small className="ms-2">2 MB</small>
                            </div>
                            <Button variant="transparent icon-btn border-0 ms-auto d-flax justify-content-center align-items-center">
                              <span className="material-symbols-outlined">
                                download
                              </span>
                            </Button>
                          </li>
                          <li className="download-item ps-2 py-1 rounded-1 border bg-white d-flex align-items-center">
                            <div className="download-item-detsils d-flex align-items-center">
                              <i className="bx bxs-file-pdf"></i>{" "}
                              <label className="ms-2">Curriculum2023.pdf</label>{" "}
                              <small className="ms-2">2 MB</small>
                            </div>
                            <Button variant="transparent icon-btn border-0 ms-auto d-flax justify-content-center align-items-center">
                              <span className="material-symbols-outlined">
                                download
                              </span>
                            </Button>
                          </li>
                          <li className="download-item ps-2 py-1 rounded-1 border bg-white d-flex align-items-center">
                            <div className="download-item-detsils d-flex align-items-center">
                              <i className="bx bxs-file-pdf"></i>{" "}
                              <label className="ms-2">Instruction.pdf</label>{" "}
                              <small className="ms-2">2 MB</small>
                            </div>
                            <Button variant="transparent icon-btn border-0 ms-auto d-flax justify-content-center align-items-center">
                              <span className="material-symbols-outlined">
                                download
                              </span>
                            </Button>
                          </li>
                          <li className="download-item ps-2 py-1 rounded-1 border bg-white d-flex align-items-center">
                            <div className="download-item-detsils d-flex align-items-center">
                              <i className="bx bxs-file-pdf"></i>{" "}
                              <label className="ms-2">Curriculum2023.pdf</label>{" "}
                              <small className="ms-2">2 MB</small>
                            </div>
                            <Button variant="transparent icon-btn border-0 ms-auto d-flax justify-content-center align-items-center">
                              <span className="material-symbols-outlined">
                                download
                              </span>
                            </Button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="drag-drop-box py-5 px-3 d-flex justify-content-center align-items-center rounded-2 bg-light height-equal">
                    Drag & Drop your filed
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="text-center">
                    <Button variant="dark btn-lg">Button Name</Button>{" "}
                    <Button variant="primary btn-lg">Button Name</Button>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="py-4 section-divider text-center">
              <span className="bg-black-50 text-black">
                <span className="pluto-page-breaker bx-xs align-middle"></span>{" "}
                Page Breaker
              </span>
            </div>
            <div className="p-3 rounded-2 bg-white border">
              {/* <div className="section-divider text-center mb-4">
                            <span className="bg-white">Add section header</span>
                        </div> */}
              <Row className="row gy-4">
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="builder-row border rounded-2 bg-light">
                    <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                      <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                          notes
                        </span>{" "}
                        Short text
                      </h4>
                      <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle copy-btn me-2">
                            content_copy
                          </span>
                        </Button>
                        <Button variant="transparent">
                          <span className="material-symbols-outlined align-middle remove-btn">
                            delete
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="builder-row-body d-flex flex-wrap">
                      <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                          <span className="material-symbols-outlined">
                            drag_indicator
                          </span>
                        </Button>
                      </div>
                      <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="shorttext">
                          <Form.Label>
                            What is your name?
                            {/* <small className="d-block">This will help us ensure accurate communication and correspondence throughout the admission process.</small> */}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Search element"
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="text-center">
                    <Button variant="dark btn-lg">Button Name</Button>{" "}
                    <Button variant="primary btn-lg">Button Name</Button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="formeditor-sidebar ms-auto sidebar-right bg-white global-tab h-100">
            <div className="p-3 h-100 d-flex flex-column">
              <Tabs
                defaultActiveKey="edit-filed"
                id="fill-tab-example"
                className="mb-3"
              >
                <Tab eventKey="edit-filed" title="Edit filed">
                  <Accordion defaultActiveKey="2">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header className="text-uppercase">
                        General Setting
                      </Accordion.Header>
                      <Accordion.Body>
                        {/* <div className="mb-3 input-sm">
                          <label for="fieldType" className="form-label">Field Type</label>
                          <select className="form-select" id="fieldType" aria-label="Default select example">
                              <option value="short_text">Short Text</option>
                              <option value="long_text">Long Text</option>
                              <option value="number">Number</option>
                              <option value="description">Description</option>
                          </select>
                      </div> */}

                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Auto complete
                          </label>
                          <div className="d-flex">
                            <div className="col-2">
                              <Dropdown
                                className="d-grid edit-option"
                                autoClose="outside"
                              >
                                <Dropdown.Toggle
                                  variant="gray-light border border-end-0 rounded-end-0"
                                  id="dropdown-basic"
                                ></Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="py-0 px-3">
                                    <Accordion
                                      defaultActiveKey="0"
                                      className="option-accordion relative"
                                    >
                                      <Accordion.Item
                                        eventKey="0"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          File: Instruction.pdf
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>

                                      <Accordion.Item
                                        eventKey="1"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          File : Curriculum2023.pdf
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="col">
                              <Dropdown
                                className="d-grid gap-2 max-230"
                                autoClose="outside"
                                align={{ lg: "end" }}
                              >
                                <Dropdown.Toggle
                                  variant="gray-light border rounded-start-0 plus-btn"
                                  id="dropdown-basic"
                                >
                                  Add Options
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="px-2">
                                    <div className="d-grid gap-2">
                                      <Dropdown
                                        className="d-grid gap-2 max-230"
                                        autoClose="outside"
                                        align={{ lg: "end" }}
                                      >
                                        <Dropdown.Toggle
                                          variant="gray-light"
                                          id="dropdown-basic"
                                        >
                                          Import from database
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          {/* <div className="item py-2 px-3">Country API</div> */}
                                          <div className="item py-2 px-3">
                                            <Form.Select aria-label="Default select example">
                                              <option>Select APT</option>
                                              <option option value="1">
                                                XYZ API
                                              </option>
                                              <option value="2">ABC API</option>
                                              <option value="3">UFC API</option>
                                            </Form.Select>
                                          </div>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                      <Dropdown
                                        className="d-grid gap-2 add-option"
                                        autoClose="outside"
                                        align={{ lg: "end" }}
                                      >
                                        <Dropdown.Toggle
                                          variant="dark plus-btn"
                                          id="dropdown-basic"
                                        >
                                          Add manually
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                          <div className="py-2 px-3">
                                            <div className="mb-3">
                                              <div className="col">
                                                <Form.Label htmlFor="inputKey">
                                                  Value
                                                </Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  id="inputKey"
                                                  aria-describedby="passwordHelpBlock"
                                                />
                                              </div>
                                            </div>
                                            <div className="gap-4">
                                              <Button variant="gray-light me-2">
                                                {t("common.button.cancel")}
                                              </Button>
                                              <Button variant="dark">
                                                Save
                                              </Button>
                                            </div>
                                          </div>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>

                        <div className="mb-3 input-sm grid-">
                          <label for="fieldName" className="form-label">
                            Old Multi Grid Options
                          </label>

                          <Dropdown
                            className="w-100"
                            autoClose="outside"
                            align={{ lg: "end" }}
                          >
                            <Dropdown.Toggle
                              variant="gray-light border down-btn w-100"
                              id="dropdown-basic"
                            >
                              Add Column details
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="grid-option-dropdown position-relative">
                              <div className="px-3 pb-3">
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item
                                    eventKey="0"
                                    className="position-relative"
                                  >
                                    <Button
                                      variant="transparent small-btn position-absolute row-delete-btn"
                                      size="sm"
                                    >
                                      <span className="material-symbols-outlined align-middle remove-btn">
                                        delete
                                      </span>
                                    </Button>
                                    <Accordion.Header>
                                      <Form.Group className="pe-5 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Row 1"
                                        />
                                      </Form.Group>
                                    </Accordion.Header>
                                    <Accordion.Body className="pt-2 ps-4 pb-0 pe-0">
                                      <Form.Group className="mb-2 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Column 1"
                                        />
                                        <Button
                                          variant="transparent small-btn"
                                          size="sm"
                                        >
                                          <span className="material-symbols-outlined align-middle remove-btn">
                                            delete
                                          </span>
                                        </Button>
                                      </Form.Group>
                                      <Form.Group className="mb-2 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Column 2"
                                        />
                                        <Button
                                          variant="transparent small-btn"
                                          size="sm"
                                        >
                                          <span className="material-symbols-outlined align-middle remove-btn">
                                            delete
                                          </span>
                                        </Button>
                                      </Form.Group>
                                      <Form.Group className="mb-2 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Column 3"
                                        />
                                        <Button
                                          variant="transparent small-btn"
                                          size="sm"
                                        >
                                          <span className="material-symbols-outlined align-middle remove-btn">
                                            delete
                                          </span>
                                        </Button>
                                      </Form.Group>
                                      <Button variant="transparent px-0">
                                        <i className="bx bxs-plus-circle me-1 align-middle"></i>
                                        Add more
                                      </Button>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                  <Accordion.Item
                                    eventKey="1"
                                    className="position-relative"
                                  >
                                    <Button
                                      variant="transparent small-btn position-absolute row-delete-btn"
                                      size="sm"
                                    >
                                      <span className="material-symbols-outlined align-middle remove-btn">
                                        delete
                                      </span>
                                    </Button>
                                    <Accordion.Header>
                                      <Form.Group className="pe-5 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Row 2"
                                        />
                                      </Form.Group>
                                    </Accordion.Header>
                                    <Accordion.Body className="pt-2 pb-0 px-0">
                                      <Form.Group className="mb-2 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Column 1"
                                        />
                                        <Button
                                          variant="transparent small-btn"
                                          size="sm"
                                        >
                                          <span className="material-symbols-outlined align-middle remove-btn">
                                            delete
                                          </span>
                                        </Button>
                                      </Form.Group>
                                      <Form.Group className="mb-2 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Column 2"
                                        />
                                        <Button
                                          variant="transparent small-btn"
                                          size="sm"
                                        >
                                          <span className="material-symbols-outlined align-middle remove-btn">
                                            delete
                                          </span>
                                        </Button>
                                      </Form.Group>
                                      <Form.Group className="mb-2 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Column 3"
                                        />
                                        <Button
                                          variant="transparent small-btn"
                                          size="sm"
                                        >
                                          <span className="material-symbols-outlined align-middle remove-btn">
                                            delete
                                          </span>
                                        </Button>
                                      </Form.Group>
                                      <Button variant="transparent px-0">
                                        <i className="bx bxs-plus-circle me-1 align-middle"></i>
                                        Add more
                                      </Button>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                  <Accordion.Item
                                    eventKey="2"
                                    className="position-relative"
                                  >
                                    <Button
                                      variant="transparent small-btn position-absolute row-delete-btn"
                                      size="sm"
                                    >
                                      <span className="material-symbols-outlined align-middle remove-btn">
                                        delete
                                      </span>
                                    </Button>
                                    <Accordion.Header>
                                      <Form.Group className="pe-5 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Row 3"
                                        />
                                      </Form.Group>
                                    </Accordion.Header>
                                    <Accordion.Body className="pt-2 pb-0 px-0">
                                      <Form.Group className="mb-2 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Column 1"
                                        />
                                        <Button
                                          variant="transparent small-btn"
                                          size="sm"
                                        >
                                          <span className="material-symbols-outlined align-middle remove-btn">
                                            delete
                                          </span>
                                        </Button>
                                      </Form.Group>
                                      <Form.Group className="mb-2 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Column 2"
                                        />
                                        <Button
                                          variant="transparent small-btn"
                                          size="sm"
                                        >
                                          <span className="material-symbols-outlined align-middle remove-btn">
                                            delete
                                          </span>
                                        </Button>
                                      </Form.Group>
                                      <Form.Group className="mb-2 d-flex">
                                        <Form.Control
                                          type="text"
                                          placeholder="Column 3"
                                        />
                                        <Button
                                          variant="transparent small-btn"
                                          size="sm"
                                        >
                                          <span className="material-symbols-outlined align-middle remove-btn">
                                            delete
                                          </span>
                                        </Button>
                                      </Form.Group>
                                      <Button variant="transparent px-0">
                                        <i className="bx bxs-plus-circle me-1 align-middle"></i>
                                        Add more
                                      </Button>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>

                                <hr className="my-1" />
                                <Button variant="transparent px-0">
                                  <i className="bx bxs-plus-circle me-1 align-middle"></i>
                                  Add more
                                </Button>

                                <div className="mt-2">
                                  <Button variant="gray-light me-2">
                                    {t("common.button.cancel")}
                                  </Button>
                                  <Button variant="dark">Save</Button>
                                </div>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        <div className="mb-3 input-sm grid-">
                          <label for="fieldName" className="form-label">
                            Multi Grid Options
                          </label>

                          <Dropdown
                            className="w-100 "
                            autoClose="outside"
                            align={{ lg: "end" }}
                          >
                            <Dropdown.Toggle
                              variant="gray-light border down-btn w-100 plus-btn"
                              id="dropdown-basic"
                            >
                              Add Column details
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="grid-option-dropdown position-relative">
                              <div className="px-3 pb-3">
                              <label for="fieldName" className="form-label">
                            Row Name{" "}
                            {/* <small>(The filed should be unique)</small> */}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fieldName"
                            placeholder="Column 1"
                          />
                                <hr className="my-1" />
                                <Button variant="transparent px-0">
                                  <i className="bx bxs-plus-circle me-1 align-middle"></i>
                                  Add more
                                </Button>

                                <div className="mt-2">
                                  <Button variant="gray-light me-2">
                                    {t("common.button.cancel")}
                                  </Button>
                                  <Button variant="dark">Save</Button>
                                </div>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Add Section Header Here
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fieldName"
                            placeholder="Add Text"
                          />
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Add Question Here
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fieldName"
                            placeholder="Add Text"
                          />
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Add Padding
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fieldName"
                            placeholder="Add Text"
                          />
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Field Name{" "}
                            <small>(The filed should be unique)</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fieldName"
                            placeholder="Candidate Name"
                          />
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Dropdown Options
                          </label>
                          <div className="d-flex">
                            <div className="col-2">
                              <Dropdown
                                className="d-grid edit-option"
                                autoClose="outside"
                              >
                                <Dropdown.Toggle
                                  variant="gray-light border border-end-0 rounded-end-0"
                                  id="dropdown-basic"
                                ></Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="py-0 px-3">
                                    <Accordion
                                      defaultActiveKey="0"
                                      className="option-accordion relative"
                                    >
                                      <Accordion.Item
                                        eventKey="0"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          Value : Afganisthan
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>

                                      <Accordion.Item
                                        eventKey="1"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          Value : Afganisthan
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>

                                      <Accordion.Item
                                        eventKey="2"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          Value : Afganisthan
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>

                                      <Accordion.Item
                                        eventKey="3"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          Value : Afganisthan
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="col">
                              <Dropdown
                                className="d-grid gap-2 w-260"
                                autoClose="outside"
                                align={{ lg: "end" }}
                              >
                                <Dropdown.Toggle
                                  variant="gray-light border rounded-start-0 plus-btn"
                                  id="dropdown-basic"
                                >
                                  Add Options
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="py-2 px-3">
                                    <div className="d-flex mb-3">
                                      {/* <div className="col-2">
                                                                        <Form.Label htmlFor="inputNumber">
                                                                            &nbsp;
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            id="inputNumber"
                                                                            placeholder="1"
                                                                            aria-label="Disabled input example"
                                                                            disabled
                                                                            readOnly
                                                                            className="rounded-end-0 border-end-0"
                                                                        />
                                                                    </div> */}
                                      <div className="col">
                                        <Form.Label htmlFor="inputValue">
                                          Value
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          id="inputValue"
                                          aria-describedby="passwordHelpBlock"
                                          className="rounded-end-0 border-end-0"
                                        />
                                      </div>
                                      <div className="col">
                                        <Form.Label htmlFor="inputKey">
                                          Key
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          id="inputKey"
                                          aria-describedby="passwordHelpBlock"
                                          className="rounded-0 border-end-0"
                                        />
                                      </div>
                                      <div className="col">
                                        <Form.Label htmlFor="parentKey">
                                          Parent
                                        </Form.Label>
                                        <Form.Select
                                          aria-label="Default select example"
                                          id="parentKey"
                                          className="rounded-start-0"
                                        >
                                          <option>Select</option>
                                          <option value="1">IN</option>
                                          <option value="2">US</option>
                                          <option value="3">EU</option>
                                        </Form.Select>
                                      </div>
                                    </div>
                                    <div className="gap-4">
                                      <Button variant="gray-light me-2">
                                        {t("common.button.cancel")}
                                      </Button>
                                      <Button variant="dark">Save</Button>
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>

                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Upload File
                          </label>
                          <div className="d-flex">
                            <div className="col-2">
                              <Dropdown
                                className="d-grid edit-option"
                                autoClose="outside"
                              >
                                <Dropdown.Toggle
                                  variant="gray-light border border-end-0 rounded-end-0"
                                  id="dropdown-basic"
                                ></Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="py-0 px-3">
                                    <Accordion
                                      defaultActiveKey="0"
                                      className="option-accordion relative"
                                    >
                                      <Accordion.Item
                                        eventKey="0"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          File: Instruction.pdf
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>

                                      <Accordion.Item
                                        eventKey="1"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          File : Curriculum2023.pdf
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="col">
                              <Dropdown
                                className="d-grid gap-2 max-300"
                                autoClose="outside"
                                align={{ lg: "end" }}
                              >
                                <Dropdown.Toggle
                                  variant="gray-light border rounded-start-0 plus-btn"
                                  id="dropdown-basic"
                                >
                                  Add Files
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="py-2 px-3">
                                    <div className="d-flex flex-wrap">
                                      <div className="col-12">
                                        <Form.Label htmlFor="filetype">
                                          File Type
                                        </Form.Label>
                                        <Form.Select
                                          aria-label="Default select example"
                                          id="filetype"
                                          className="rounded border-1"
                                        >
                                          <option>select</option>
                                          <option value="1">PDF</option>
                                          <option value="2">DOC</option>
                                          <option value="3">JPG</option>
                                        </Form.Select>
                                      </div>

                                      <div className="col-12">
                                        <Form.Group
                                          controlId="formFile"
                                          className="mb-3"
                                        >
                                          <Form.Label>
                                            Default file input example
                                          </Form.Label>
                                          <Form.Control
                                            type="file"
                                            className=""
                                          />
                                        </Form.Group>
                                      </div>
                                    </div>
                                    <div className="gap-4">
                                      <Button variant="gray-light me-2">
                                        {t("common.button.cancel")}
                                      </Button>
                                      <Button variant="dark">Save</Button>
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>

                        <div className="mb-3 input-sm">
                          <label for="placeholderText" className="form-label">
                            Placeholder text
                          </label>
                          <textarea
                            className="form-control"
                            id="placeholderText"
                            rows="3"
                            placeholder="Add Text"
                          ></textarea>
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="placeholderReason" className="form-label">
                            Reason for the filed
                          </label>
                          <textarea
                            className="form-control"
                            id="placeholderReason"
                            rows="3"
                            placeholder="Add Text"
                          ></textarea>
                        </div>
                        <div className="mb-3 input-sm">
                          <label className="form-label">Button Color</label>
                          <Dropdown className="d-grid gap-2">
                            <Dropdown.Toggle
                              variant="gray-light border arrow-btn"
                              id="dropdown-basic"
                            >
                              <div className="d-flex align-items-center">
                                <div className="color-code me-2">
                                  <input
                                    type="radio"
                                    className="btn-check"
                                    name="options"
                                    id="option2"
                                    autocomplete="off"
                                  />
                                  <label
                                    className="btn btn-secondary rounded-1"
                                    for="option2"
                                  ></label>
                                </div>
                                <span>Orange #E57524</span>
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="w-full p-2">
                              <ul className="builder-color-list m-0 p-0">
                                <li className="d-flex align-items-center">
                                  <div className="color-code me-2">
                                    <input
                                      type="radio"
                                      className="btn-check"
                                      name="options"
                                      id="option1"
                                      autocomplete="off"
                                    />
                                    <label
                                      className="btn btn-primary rounded-1"
                                      for="option1"
                                    ></label>
                                  </div>
                                  <span>Blue #182A58</span>
                                </li>
                                <li className="d-flex align-items-center">
                                  <div className="color-code me-2">
                                    <input
                                      type="radio"
                                      className="btn-check"
                                      name="options"
                                      id="option2"
                                      autocomplete="off"
                                    />
                                    <label
                                      className="btn btn-secondary rounded-1"
                                      for="option2"
                                    ></label>
                                  </div>
                                  <span>Orange #E57524</span>
                                </li>
                              </ul>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="mb-3 input-sm">
                          <label className="form-label">Text Color</label>
                          <Dropdown className="d-grid gap-2">
                            <Dropdown.Toggle
                              variant="gray-light border arrow-btn"
                              id="dropdown-basic"
                            >
                              <div className="d-flex align-items-center">
                                <div className="color-code me-2">
                                  <input
                                    type="radio"
                                    className="btn-check"
                                    name="options"
                                    id="option2"
                                    autocomplete="off"
                                  />
                                  <label
                                    className="btn btn-secondary rounded-1"
                                    for="option2"
                                  ></label>
                                </div>
                                <span>Orange #E57524</span>
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="w-full p-2">
                              <ul className="builder-color-list m-0 p-0">
                                <li className="d-flex align-items-center">
                                  <div className="color-code me-2">
                                    <input
                                      type="radio"
                                      className="btn-check"
                                      name="options"
                                      id="option1"
                                      autocomplete="off"
                                    />
                                    <label
                                      className="btn btn-primary rounded-1"
                                      for="option1"
                                    ></label>
                                  </div>
                                  <span>Blue #182A58</span>
                                </li>
                                <li className="d-flex align-items-center">
                                  <div className="color-code me-2">
                                    <input
                                      type="radio"
                                      className="btn-check"
                                      name="options"
                                      id="option2"
                                      autocomplete="off"
                                    />
                                    <label
                                      className="btn btn-secondary rounded-1"
                                      for="option2"
                                    ></label>
                                  </div>
                                  <span>Orange #E57524</span>
                                </li>
                              </ul>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="columnSpan" className="form-label">
                            Column Span
                          </label>
                          <select
                            className="form-select"
                            id="columnSpan"
                            aria-label="Default select example"
                          >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                          </select>
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Checkbox Options
                          </label>
                          <div className="d-flex">
                            <div className="col-2">
                              <Dropdown
                                className="d-grid edit-option"
                                autoClose="outside"
                              >
                                <Dropdown.Toggle
                                  variant="gray-light border border-end-0 rounded-end-0"
                                  id="dropdown-basic"
                                ></Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="py-0 px-3">
                                    <Accordion
                                      defaultActiveKey="0"
                                      className="option-accordion relative"
                                    >
                                      <Accordion.Item
                                        eventKey="0"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          File: Instruction.pdf
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>

                                      <Accordion.Item
                                        eventKey="1"
                                        className="relative"
                                      >
                                        <Accordion.Header>
                                          File : Curriculum2023.pdf
                                        </Accordion.Header>
                                        <div className="edit-dlt-btn">
                                          <Button variant="transparent">
                                            <i className="bx bx-pencil"></i>
                                          </Button>
                                          <Button variant="transparent">
                                            <i className="bx bx-trash-alt"></i>
                                          </Button>
                                        </div>
                                        <Accordion.Body className="pb-0">
                                          <ul className="m-0 p-0">
                                            <li>
                                              <strong>Value :</strong> Antigua
                                              and barbua
                                            </li>
                                            <li>
                                              <strong>Key :</strong> ANBR
                                            </li>
                                          </ul>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="col">
                              <Dropdown
                                className="d-grid gap-2 max-230"
                                autoClose="outside"
                                align={{ lg: "end" }}
                              >
                                <Dropdown.Toggle
                                  variant="gray-light border rounded-start-0 plus-btn"
                                  id="dropdown-basic"
                                >
                                  Add Options
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="px-2">
                                    <div className="d-grid gap-2">
                                      <Dropdown
                                        className="d-grid gap-2 max-230"
                                        autoClose="outside"
                                        align={{ lg: "end" }}
                                      >
                                        <Dropdown.Toggle
                                          variant="gray-light"
                                          id="dropdown-basic"
                                        >
                                          Import from database
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          {/* <div className="item py-2 px-3">Country API</div> */}
                                          <div className="item py-2 px-3">
                                            <Form.Select aria-label="Default select example">
                                              <option>Select APT</option>
                                              <option option value="1">
                                                XYZ API
                                              </option>
                                              <option value="2">ABC API</option>
                                              <option value="3">UFC API</option>
                                            </Form.Select>
                                          </div>
                                          {/* <div className="search-div mb-3">
                                                                                <InputGroup className="mb-3">
                                                                                    <InputGroup.Text id="basic-addon1"><i className="pluto-search"></i></InputGroup.Text>
                                                                                    <Form.Control
                                                                                        placeholder="Search option"
                                                                                        aria-label="Username"
                                                                                        aria-describedby="basic-addon1"
                                                                                    />
                                                                                </InputGroup>
                                                                            </div> */}
                                          {/* <ListGroup className=" py-2 px-3">
                                                                                <ListGroup.Item>XYZ API</ListGroup.Item>
                                                                                <ListGroup.Item>ABC API</ListGroup.Item>
                                                                                <ListGroup.Item>UFC API</ListGroup.Item>
                                                                            </ListGroup> */}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                      {/* <Button variant="dark btn-sm">Add manually</Button> */}
                                      <Dropdown
                                        className="d-grid gap-2 add-option"
                                        autoClose="outside"
                                        align={{ lg: "end" }}
                                      >
                                        <Dropdown.Toggle
                                          variant="dark plus-btn"
                                          id="dropdown-basic"
                                        >
                                          Add manually
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          <div className="py-2 px-3">
                                            <div className="d-flex mb-3">
                                              <div className="col">
                                                <Form.Label htmlFor="inputValue">
                                                  Key
                                                </Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  id="inputValue"
                                                  aria-describedby="passwordHelpBlock"
                                                  className="rounded-end-0 border-end-0"
                                                />
                                              </div>
                                              <div className="col">
                                                <Form.Label htmlFor="inputKey">
                                                  Value
                                                </Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  id="inputKey"
                                                  aria-describedby="passwordHelpBlock"
                                                  className="rounded-0 border-end-0"
                                                />
                                              </div>
                                              {/* <div className="col">
                                                                                        <Form.Label htmlFor="parentKey">
                                                                                            Parent
                                                                                        </Form.Label>
                                                                                        <Form.Select aria-label="Default select example" id="parentKey" className="rounded-0">
                                                                                            <option>Select</option>
                                                                                            <option value="1">IN</option>
                                                                                            <option value="2">US</option>
                                                                                            <option value="3">EU</option>
                                                                                        </Form.Select>
                                                                                    </div> */}
                                              <div className="col-2">
                                                <Form.Label htmlFor="parentKey">
                                                  Parent
                                                </Form.Label>
                                                <Dropdown>
                                                  <Dropdown.Toggle
                                                    variant="light btn-xs rounded-start-0 w-100 border-bottom-0"
                                                    id="dropdown-basic"
                                                  ></Dropdown.Toggle>

                                                  <Dropdown.Menu className="p-3">
                                                    <div className="select-group">
                                                      <div className="selected-options">
                                                        <input
                                                          className="search-input"
                                                          placeholder="Search"
                                                          type="text"
                                                        />
                                                      </div>
                                                      <ListGroup className="select-dropdown">
                                                        <ListGroup.Item>
                                                          <label>
                                                            <input
                                                              type="checkbox"
                                                              className="form-check-input me-2"
                                                            />
                                                            Select All
                                                          </label>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                          <label>
                                                            <input
                                                              type="checkbox"
                                                              className="form-check-input me-2"
                                                            />
                                                            Deutschland
                                                          </label>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                          <label>
                                                            <input
                                                              type="checkbox"
                                                              className="form-check-input me-2"
                                                            />
                                                            Indian
                                                          </label>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                          <label>
                                                            <input
                                                              type="checkbox"
                                                              className="form-check-input me-2"
                                                            />
                                                            Pakistani
                                                          </label>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                          <label>
                                                            <input
                                                              type="checkbox"
                                                              className="form-check-input me-2"
                                                            />
                                                            Jordan
                                                          </label>
                                                        </ListGroup.Item>
                                                      </ListGroup>
                                                    </div>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </div>
                                            </div>
                                            <div className="gap-4">
                                              <Button variant="gray-light me-2">
                                                {t("common.button.cancel")}
                                              </Button>
                                              <Button variant="dark">
                                                Save
                                              </Button>
                                            </div>
                                          </div>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="parent-filed"
                            >
                              Dependent on Parent filed
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="parent-filed"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label className="form-check-label" for="file-type">
                              Allowed File Type
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="file-type"
                            />
                          </div>

                          <Form>
                            {["checkbox"].map((type) => (
                              <div key={`file-type-${type}`} className="mb-3">
                                <Form.Check
                                  label="JPG"
                                  name="group1"
                                  type={type}
                                  id={`file-type-${type}-jpg`}
                                />
                                <Form.Check
                                  label="PNG"
                                  name="group1"
                                  type={type}
                                  id={`file-type-${type}-png`}
                                />
                                <Form.Check
                                  label="PDF"
                                  name="group1"
                                  type={type}
                                  id={`file-type-${type}-pdf`}
                                />
                                <Form.Check
                                  label="DOX"
                                  name="group1"
                                  type={type}
                                  id={`file-type-${type}-dox`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Add image caption
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fieldName"
                            placeholder="Add Text"
                          />
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Field Name{" "}
                            <small>(The filed should be unique)</small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fieldName"
                            placeholder="Personality Trait"
                          />
                        </div>
                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Upload image
                          </label>
                          <div className="mb-3 file-input-box bg-white px-3 py-2 border rounded cursor-pointer">
                            <label
                              for="file"
                              className="d-block text-center d-flex align-items-center cursor-pointer"
                            >
                              <span className="mb-0 text-sm text-primary">
                                testimage.jpg
                              </span>
                              <span className="material-symbols-outlined ms-auto text-lg">
                                upload
                              </span>
                            </label>
                            <input type="file" id="file" className="d-none" />
                          </div>
                        </div>

                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Add Video Link
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fieldName"
                            placeholder="www.youtube.com/video"
                          />
                        </div>

                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Add Video
                          </label>
                          <div className="row gx-2">
                            <div className="col-6">
                              
                              <div className="px-3 py-2 border border-slate-200 bg-slate-50 text-decoration-none rounded font-medium">
                                <label
                                  for="file"
                                  className="d-block text-center d-flex align-items-center cursor-pointer"
                                >
                                  <i className="bx bxs-videos me-1 text-lg"></i>
                                  <span className="mb-0 text-sm text-primary">
                                    Upload Video
                                  </span>                                  
                                </label>
                                <input type="file" id="file" className="d-none" />
                              </div>
                            </div>


                            <div className="col-6">                              
                              <Button onClick={handleShow}  className="px-3 py-2 border border-slate-200 bg-slate-50 text-decoration-none rounded font-medium text-dark d-inline-flex align-items-center gap-1 w-100"><i className="bx bx-video text-lg"></i> Get Camera</Button>

                                
                            </div>
                          </div>
                        </div>

                        <Modal show={show} onHide={handleClose}>
                          <Modal.Header closeButton>
                            <Modal.Title>Modal heading</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form>
                              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                  type="email"
                                  placeholder="name@example.com"
                                  autoFocus
                                />
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                              >
                                <Form.Label>Example textarea</Form.Label>
                                <Form.Control as="textarea" rows={3} />
                              </Form.Group>
                            </Form>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                              Close
                            </Button>
                            <Button variant="primary" onClick={handleClose}>
                              Save Changes
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        <div className="mb-3 input-sm">
                          <label for="description" className="form-label">
                            Description
                          </label>
                          <textarea
                            rows={6}
                            className="form-control"
                            id="description"
                            placeholder="Welcome to the EdTech UX Survey!"
                          ></textarea>
                        </div>

                        <div className="mb-3 input-sm">
                          <label for="columnSpan" className="form-label">
                            Choose Parent field
                          </label>
                          <select
                            className="form-select"
                            id="columnSpan"
                            aria-label="Default select example"
                          >
                            <option value="1">Country</option>
                            <option value="2">India</option>
                            <option value="3">UAE</option>
                          </select>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Required Field
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Hidden Field
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Internal Field
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Validate Field</Accordion.Header>
                      <Accordion.Body>
                        <div className="input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Field Length
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="row">
                            <div className="col">
                              <label for="fieldType" className="form-label">
                                Min character
                              </label>
                              <select
                                className="form-select"
                                id="fieldType"
                                aria-label="Default select example"
                              >
                                <option>select</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="40">40</option>
                                <option value="50">50</option>
                              </select>
                            </div>
                            <div className="col">
                              <label for="fieldType" className="form-label">
                                Max character
                              </label>
                              <select
                                className="form-select"
                                id="fieldType"
                                aria-label="Default select example"
                              >
                                <option>select</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="40">40</option>
                                <option value="50">50</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Character Type
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          {/* <label for="fieldType" className="form-label">Min character</label> */}
                          <select
                            className="form-select"
                            id="fieldType"
                            aria-label="Default select example"
                          >
                            <option>Alphabet</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                            <option value="50">50</option>
                          </select>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <label for="fieldName" className="form-label">
                            Field Pattern
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="fieldName"
                            placeholder="ABC-DEF-GHI-JK"
                          />
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Numeric Type
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <Form>
                            {["checkbox"].map((type) => (
                              <div key={`reverse-${type}`} className="mb-3">
                                <Form.Check
                                  label="Integer Value"
                                  name="group1"
                                  type={type}
                                  id={`reverse-${type}-1`}
                                />
                                <Form.Check
                                  label="Decimal Value"
                                  name="group1"
                                  type={type}
                                  id={`reverse-${type}-2`}
                                />
                              </div>
                            ))}
                          </Form>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Measurment Unit
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <Form.Select aria-label="Default select example">
                            <option>Persentage</option>
                            <option value="1">Standerd</option>
                            <option value="2">MAAC</option>
                            <option value="3">Three</option>
                          </Form.Select>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Navigation Number
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Default Value
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <Form.Select aria-label="Default select example">
                            <option>Select Value</option>
                            <option value="1">Value 1</option>
                            <option value="2">Value 2</option>
                            <option value="3">Value 3</option>
                          </Form.Select>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Others Options
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Conditional
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Allowed Years
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="row">
                            <div className="col">
                              <label for="fieldType" className="form-label">
                                Current +
                              </label>
                              <select
                                className="form-select"
                                id="fieldType"
                                aria-label="Default select example"
                              >
                                <option>select</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="40">40</option>
                                <option value="50">50</option>
                              </select>
                            </div>
                            <div className="col">
                              <label for="fieldType" className="form-label">
                                Current -
                              </label>
                              <select
                                className="form-select"
                                id="fieldType"
                                aria-label="Default select example"
                              >
                                <option>select</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="40">40</option>
                                <option value="50">50</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Disable Date Past
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          {/* <div className="input-group mb-3">
                          <input type="date" className="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2"/>
                          <span className="input-group-text" id="basic-addon2"><span className="material-symbols-outlined">calendar_month</span></span>
                        </div> */}
                          <input
                            type="date"
                            className="form-control"
                            id="fieldName"
                            placeholder="Choose date"
                          />
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Disable Time Frame
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="row">
                            <div className="col">
                              <label for="fieldType" className="form-label">
                                Start form
                              </label>
                              <input
                                type="time"
                                className="form-control"
                                id="fieldName"
                                placeholder="Choose date"
                              />
                            </div>
                            <div className="col">
                              <label for="fieldType" className="form-label">
                                End at
                              </label>
                              <input
                                type="time"
                                className="form-control"
                                id="fieldName"
                                placeholder="Choose date"
                              />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Date Format
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <Form.Select aria-label="Default select example">
                            <option>DD/MM/YY</option>
                            <option value="1">MM/DD/YY</option>
                            <option value="2">YY/DD/MM</option>
                            <option value="3">YY/MM/DD</option>
                          </Form.Select>
                        </div>
                        <hr />
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault"
                            >
                              Time Format
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <Form.Select aria-label="Default select example">
                            <option>12 hr</option>
                            <option value="1">24 hr</option>
                          </Form.Select>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                      <Accordion.Header>Field</Accordion.Header>
                      <Accordion.Body>
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="FiledLength"
                            >
                              Filed Length
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="FiledLength"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="CharacterType"
                            >
                              Character Type
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="CharacterType"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="FieldMapping"
                            >
                              Field Mapping
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="FieldMapping"
                            />
                          </div>
                        </div>
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="FieldPattern"
                            >
                              Field Pattern
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="FieldPattern"
                            />
                          </div>
                        </div>
                        <div className="mb-3 border rounded-3">
                          <Accordion defaultActiveKey="0">
                            <Accordion.Item
                              eventKey="0"
                              className="bg-transparent border-bottom"
                            >
                              <Accordion.Header className="px-2">
                                Map filed
                              </Accordion.Header>
                              <Accordion.Body className="px-2">
                                <div className="mb-3">
                                  <div className="mb-3 input-sm switch-row position-relative">
                                    <div className="row">
                                      <div className="col">
                                        <label
                                          for="fieldType"
                                          className="form-label"
                                        >
                                          Map filed
                                        </label>
                                        <select
                                          className="form-select"
                                          id="fieldType"
                                          aria-label="Default select example"
                                        >
                                          <option>Value 1</option>
                                          <option value="20">20</option>
                                          <option value="30">30</option>
                                          <option value="40">40</option>
                                          <option value="50">50</option>
                                        </select>
                                      </div>
                                      <div className="col">
                                        <label
                                          for="fieldType"
                                          className="form-label text-orange-900"
                                        >
                                          To Data Source
                                        </label>
                                        <select
                                          className="form-select"
                                          id="fieldType"
                                          aria-label="Default select example"
                                        >
                                          <option>Multi select</option>
                                          <option value="20">20</option>
                                          <option value="30">30</option>
                                          <option value="40">40</option>
                                          <option value="50">50</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-end btn-small">
                                    <Button variant="light" size="sm">
                                      Cancel
                                    </Button>
                                  </div>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item
                              eventKey="1"
                              className="bg-transparent"
                            >
                              <Accordion.Header className="px-2">
                                Calculate field
                              </Accordion.Header>
                              <Accordion.Body className="px-2">
                                <div className="mb-3 input-sm">
                                  <label
                                    for="CalculateFiled"
                                    className="form-label"
                                  >
                                    Calculate filed
                                  </label>
                                  <select
                                    className="form-select"
                                    id="CalculateFiled"
                                    aria-label="Default select example"
                                  >
                                    <option>Date calculation</option>
                                    <option>Numeric calculation</option>
                                  </select>
                                </div>
                                <div className="mb-3 input-sm">
                                  <label
                                    for="CalculateFiled"
                                    className="form-label text-orange-900"
                                  >
                                    Define equation
                                  </label>
                                  <div className="border rounded-3">
                                    <div className="p-2">
                                      <div className="row g-0">
                                        <div className="col-5">
                                          <span
                                            type="button"
                                            className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-2 position-relative text-wrap text-start"
                                          >
                                            fieldID: submission_date
                                            <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle">
                                              <i className="bx bx-x"></i>
                                            </span>
                                          </span>
                                          <span
                                            type="button"
                                            className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-2 position-relative text-wrap text-start"
                                          >
                                            fieldID:type2fieldname
                                            <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle">
                                              <i className="bx bx-x"></i>
                                            </span>
                                          </span>
                                        </div>
                                        <div className="col-2 btn-small text-center">
                                          <Button
                                            variant="light"
                                            size="sm"
                                            className="px-2"
                                          >
                                            <i className="bx bx-plus"></i>
                                          </Button>
                                        </div>
                                        <div className="col-5">
                                          <span
                                            type="button"
                                            className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-2 position-relative text-wrap text-start"
                                          >
                                            fieldID:dateofbirth
                                            <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle">
                                              <i className="bx bx-x"></i>
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="bg-light p-2">
                                      <div className="row g-2">
                                        <div className="col">
                                          <select
                                            className="form-select"
                                            id="fieldType"
                                            aria-label="Default select example"
                                          >
                                            <option>Select field</option>
                                            <option value="20">20</option>
                                            <option value="30">30</option>
                                            <option value="40">40</option>
                                            <option value="50">50</option>
                                          </select>
                                        </div>
                                        <div className="col">
                                          <select
                                            className="form-select"
                                            id="fieldType"
                                            aria-label="Default select example"
                                          >
                                            <option>Operators</option>
                                            <option value="20">20</option>
                                            <option value="30">30</option>
                                            <option value="40">40</option>
                                            <option value="50">50</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="text-end btn-small">
                                  <Button variant="light" size="sm">
                                    Cancel
                                  </Button>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </div>

                        <hr />

                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="FieldPattern"
                            >
                              Calculate filed
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="FieldPattern"
                            />
                          </div>
                        </div>

                        <div className="mb-3 input-sm">
                          <label for="CalculateFiled" className="form-label">
                            Calculate filed
                          </label>
                          <select
                            className="form-select"
                            id="CalculateFiled"
                            aria-label="Default select example"
                          >
                            <option>Date calculation</option>
                            <option>Time calculation</option>
                          </select>
                        </div>
                        <div className="mb-3 input-sm">
                          <label
                            for="CalculateFiled"
                            className="form-label text-orange-900"
                          >
                            Define equation
                          </label>
                          <div className="mb-3 border rounded-3">
                            <div className="p-2 define-box">
                              <div className="row justify-content-between g-0 position-relative">
                                <div className="col-5">
                                  <span
                                    type="button"
                                    className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-1 position-relative text-wrap text-start w-100"
                                  >
                                    fieldID:submission_date
                                    <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle"></span>
                                  </span>
                                </div>
                                <div className="col-5">
                                  <span
                                    type="button"
                                    className="mb-1 badge badge-text-sm font-normal text-success-emphasis bg-success-subtle border border-success-subtle rounded-1 position-relative text-wrap text-start w-100"
                                  >
                                    fieldID:dateofbirth
                                    <span className="position-absolute top-0 start-100 translate-middle p-0 text-white bg-dark border border-light rounded-circle"></span>
                                  </span>
                                </div>
                                <div className="position-absolute btn-small text-center calculator-position">
                                  <Button
                                    variant="light"
                                    size="sm"
                                    className="px-2 py-0"
                                  >
                                    <i className="bx bx-minus"></i>
                                  </Button>
                                </div>
                              </div>
                            </div>
                            <div className="bg-light p-2">
                              <div className="row g-2">
                                <div className="col">
                                  <select
                                    className="form-select"
                                    id="fieldType"
                                    aria-label="Default select example"
                                  >
                                    <option>Add field</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="calculator">
                              <div className="calculator__keys">
                                <button className="calculator__key">1</button>
                                <button className="calculator__key">2</button>
                                <button className="calculator__key">3</button>
                                <button className="calculator__key">4</button>
                                <button className="calculator__key">5</button>
                                <button className="calculator__key">6</button>
                                <button className="calculator__key">7</button>
                                <button className="calculator__key">8</button>
                                <button className="calculator__key">9</button>
                                <button className="calculator__key">0</button>
                                <button className="calculator__key">.</button>
                                <button className="calculator__key">(</button>
                                <button className="calculator__key">)</button>
                                <button className="calculator__key calculator__key--operator">
                                  +
                                </button>
                                <button className="calculator__key calculator__key--operator">
                                  -
                                </button>
                                <button className="calculator__key calculator__key--operator">
                                  &times;
                                </button>
                                <button className="calculator__key calculator__key--operator">
                                  ÷
                                </button>
                                <button className="calculator__key">AC</button>
                                <button className="calculator__key calculator__key--enter">
                                  =
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label
                              for="CalculateFiled"
                              className="form-label text-orange-900"
                            >
                              Expect result in
                            </label>

                            <select
                              className="form-select"
                              id="CalculateFiled"
                              aria-label="Default select example"
                            >
                              <option>Date</option>
                              <option selected>Month</option>
                              <option>Year</option>
                            </select>
                          </div>

                          <div className="text-end btn-small">
                            <button
                              type="button"
                              className="btn btn-transparent btn-sm me-2"
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-dark btn-sm"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Tab>
                <Tab eventKey="logic" title="Logic">
                  <div className="email-form form-body pe-1">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="parent-filed"
                            >
                              Dependent on Parent filed
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="parent-filed"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label className="form-check-label" for="file-type">
                              Allowed File Type
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="file-type"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="mb-3 input-sm">
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="mb-3 input-sm">
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="mb-3 input-sm">
                          <label className="form-label">Choose Project</label>
                          <select className="form-select">
                            <option>Select</option>
                            <option>Cybersecurity and Dependability</option>
                            <option>Systems (Computer Science)</option>
                            <option>
                              Methodology Development in Bioinformatics
                            </option>
                            <option>
                              Mathematical Foundations of Data Science-Approve
                            </option>
                            <option>System Testing-Deny</option>
                            <option>
                              Mathematical Foundations of Data Science for
                              2021-2022 for XYZ Labs Super Computing
                            </option>
                            <option>
                              Cybersecurity and Dependability-Deny
                            </option>
                            <option>Systems (Computer Science)-Deny</option>
                            <option>
                              Mathematical Foundations of Data Science-Final
                              Deny
                            </option>
                            <option>Cybersecurity Test</option>
                            <option>
                              Faculty positions in Computer Science-Deny
                            </option>
                            <option>Systems (Computer Science)-Approve</option>
                            <option>
                              Systems (Computer Science)-Final Deny
                            </option>
                            <option>
                              Methodology Development in Bioinformatics-Deny
                            </option>
                            <option>
                              Methodology Development in Bioinformatics-Final
                              Deny
                            </option>
                            <option>
                              Mathematical Foundations of Data Science-Deny
                            </option>
                            <option>
                              Cybersecurity and Dependability-Final Deny
                            </option>
                            <option>
                              Cybersecurity and Dependability-Approve
                            </option>
                            <option>
                              Methodology Development in Bioinformatics-Approve
                            </option>
                            <option>
                              Faculty positions in Computer Science-Approve
                            </option>
                            <option>
                              Faculty positions in Computer Science-Final Deny
                            </option>
                            <option>Cybersecurity</option>
                            <option>Cybersecurity Testing</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="mb-3 input-sm">
                          <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success">
                            <label
                              className="form-check-label"
                              for="parent-filed"
                            >
                              Enable
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="parent-filed"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="if-wrapper">
                      <div className="step-row mb-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <label>If</label>
                        </div>
                        <div className="row align-items-center">
                          <div className="col-lg-5 col-md-5 col-sm-6 col-12">
                            <div className="mb-3">
                              <select className="form-select">
                                <option value="">All</option>
                                <option value="">Any</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-7 col-md-5 col-sm-6 col-12">
                            <div className="mb-3">
                              <strong className="small">
                                of the following is true
                              </strong>
                            </div>
                          </div>
                        </div>
                        <div className="add-row-wrapper">
                          <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                              <div className="mb-3">
                                <select className="form-select">
                                  <option value="">Select</option>
                                  <option value="1">name</option>
                                  <option value="2">Citizenship</option>
                                  <option value="3">PhD Institution</option>
                                  <option value="5">
                                    Institution granting PhD
                                  </option>
                                  <option value="4">PhD Year</option>
                                  <option value="6">Application Date</option>
                                  <option value="7">Assignee</option>
                                  <option value="90">Ranking</option>
                                  <option value="8">Status</option>
                                  <option value="9">
                                    Publications Profile URL
                                  </option>
                                  <option value="10">
                                    Current Affiliation
                                  </option>
                                  <option value="17">Rating</option>
                                  <option value="18">
                                    LinkedIn Profile URL
                                  </option>
                                  <option value="14">References</option>
                                  <option value="15">Title of PhD</option>
                                  <option value="16">Last5yearsh-index</option>
                                  <option value="17">
                                    Last5yearsCitations
                                  </option>
                                  <option value="18">i10-index</option>
                                  <option value="20">Citations</option>
                                  <option value="21">h-index</option>
                                  <option value="24">
                                    Number of supervised or co-supervised PhD
                                    students (ongoing)
                                  </option>
                                  <option value="13">Comments</option>
                                  <option value="22">
                                    Subject Area of PhD
                                  </option>
                                  <option value="25">
                                    Primary Area of Expertise
                                  </option>
                                  <option value="23">
                                    Number of supervised or co-supervised PhD
                                    students (graduated)
                                  </option>
                                  <option value="26">
                                    Last5yearsi10-index
                                  </option>
                                  <option value="27">LastDateSent</option>
                                  <option value="36">Tag</option>
                                  <option value="37">Files</option>
                                  <option value="39">Due Date</option>
                                  <option value="35">Image</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                              <div className="mb-3">
                                <select className="form-select">
                                  <option>Select</option>
                                  <option value="equals">equals</option>
                                  <option value="not equals">not equals</option>
                                  <option value="in this list">
                                    in this list
                                  </option>
                                  <option value="not in this list">
                                    not in this list
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Text here"
                                />
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-5 col-sm-6 col-12">
                              <div className="d-flex column-gap-2">
                                <button type="button" className="delete-btn">
                                  <i className="bx bx-plus"></i>
                                </button>
                                <button type="button" className="delete-btn">
                                  <i className="bx bx-x"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bachcolor-color">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-block d-flex justify-content-between align-items-center"
                        >
                          And/Or <i className="bx bx-plus bx-sm"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>

              <div className="mt-3 d-grid gap-2">
                <Button variant="dark">
                  <i className="bx bx-save bx-sm align-middle"></i> Save in
                  Database
                </Button>
                <Button variant="gray-light">
                  <i className="bx bx-globe bx-sm align-middle"></i> Save as
                  Global Field
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default FormDesignCOPY;
